import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = {
  for: "input-file",
  class: "block text-sm font-medium text-gray-700 mb-1"
}
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_4 = { class: "flex border border-gray-300 bg-white rounded-md" }
const _hoisted_5 = { class: "inline-flex items-center px-3 bg-gray-50 text-gray-500 sm:text-sm border-r rounded-l-md cursor-pointer relative overflow-hidden" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Browse...", -1)
const _hoisted_7 = ["accept"]
const _hoisted_8 = { class: "shadow-sm block flex-1 sm:text-sm min-w-0 px-3 py-2 overflow-hidden" }
const _hoisted_9 = {
  key: 0,
  "data-testid": "file_name"
}
const _hoisted_10 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_11 = { class: "pt-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_13 = {
  key: 0,
  class: "pt-2"
}
const _hoisted_14 = { class: "text-sm text-red-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_snap_icon = _resolveComponent("snap-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
      (_ctx.cornerHint)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.cornerHint), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("input", {
          type: "file",
          id: "input-file",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onFileChange($event))),
          class: "absolute inset-0 opacity-0 cursor-pointer",
          accept: _ctx.accept
        }, null, 40, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.file)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.file?.name), 1))
          : _createCommentVNode("", true),
        (!_ctx.file)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "No file selected"))
          : _createCommentVNode("", true)
      ]),
      (_ctx.file)
        ? (_openBlock(), _createBlock(_component_snap_icon, {
            key: 0,
            icon: "x-solid",
            size: "xs",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clear())),
            class: "cursor-pointer px-2"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.helpText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.helpText), 1))
        : _createCommentVNode("", true)
    ]),
    (!!_ctx.validation && _ctx.validation.$invalid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.validation?.$silentErrors[0]?.$message), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}